module.exports = __webpack_public_path__ + "img/log-deca-012.d9c2283c.png";